/**
* @file 线路管理
* */
<template>
  <div id="czLine">
    <custom-table
      ref="customTable"
      has-organization="true"
      :customOptions="customOptions"
      :columns="columns"
      addText="创建发车场站"
      @addFn="addFn"
    >
      <template slot="table-operation">
        <el-table-column label="操作" fixed="right" width="150px">
          <div slot-scope="{ row }" class="custom-action">
            <el-button type="text" @click="edit(row)">编辑</el-button>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'vehicleNum'">
          <span class="aTag" @click="showDrawer(row)"
            >{{ row.vehicleNum }}辆</span
          >
        </template>
        <template v-else-if="item.prop === 'status'">
          <el-switch
            class="tableScopeSwitch"
            v-model="row.status"
            :active-value="1"
            :inactive-value="2"
            active-text="启用"
            inactive-text="停用"
            @change="updateStatus($event, row)"
          >
          </el-switch>
        </template>
        <template v-else>
          <span>{{ row[item.prop] ? row[item.prop] : "-" }}</span>
        </template>
      </template>
    </custom-table>

    <el-dialog
      v-if="dialogVisible"
      title="场站信息"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      width="920px"
    >
      <div>
        <div class="mapContent">
          <div class="buttons">
            <choose-address
              :value.sync="searchText"
              placeholder="在地图上搜索位置"
              :citycode="cityAdcode"
              @clickRowFn="clickPoint"
              style="width: 200px"
            ></choose-address>
            <div class="mapBtn" @click="emptyPolygon">清空围栏</div>
            <div class="mapBtn" @click="clickHollow">挖空围栏</div>
          </div>
          <div id="mapCtx"></div>
        </div>

        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
          <el-form-item label="机构名称" prop="organizationId">
            <el-select
              v-model="form.organizationId"
              placeholder="请选择机构名称"
              clearable
              :disabled="rowData.id ? true : false"
            >
              <el-option
                v-for="item in organizations"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场站名称" prop="stationName">
            <el-input
              v-model="form.stationName"
              placeholder="请输入场站名称"
              :maxlength="30"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>

    <el-drawer title="" :visible.sync="drawer" :before-close="drawerClose">
      <div style="padding:0 20px">
        <div style="font-size:15px;font-weight:600;color:#303133;padding:16px 0 12px;border-bottom:1px solid #EBEEF5;margin-bottom:12px">排队车辆</div>
        <el-table
          :data="tableData"
          height="85vh"
          border
          stripe
          style="margin-top: 10px"
        >
          <el-table-column
            v-for="item in vehicleColumns"
            :key="item.prop"
            :prop="item.prop"
            :label="item.label"
          >
            <template slot-scope="{ row }">
              <span v-if="item.prop === 'licenseNo'">
                <span v-if="row.licenseNo" :style="getPlateStyle(row.licenseNo)">{{ formatPlateNumber(row.licenseNo) }}</span>
                <span v-else style="color:#999">-</span>
              </span>
              <span v-else>{{ row[item.prop] || '-' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import AMap from "AMap";
import polygonClipping from "polygon-clipping";
import isPolygonsOverlap from "@/assets/js/polygon";
export default {
  name: "czLine",
  data() {
    return {
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/airport/stationRail",
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {
            type: "input",
            field: "stationName",
            name: "场站名称",
            value: "",
          },
          {
            type: "select",
            field: "status",
            name: "场站状态",
            value: "",
            option: [
              {
                label: "启用",
                value: 1,
              },
              {
                label: "停用",
                value: 2,
              },
            ],
          },
        ],
      },
      // 表头
      columns: [
        { prop: "stationName", label: "场站名称" },
        { prop: "city", label: "所在城市" },
        { prop: "status", label: "场站状态" },
        { prop: "vehicleNum", label: "排队车辆" },
      ],
      tableData: [],
      vehicleColumns: [
        { prop: "licenseNo", label: "排队车辆" },
        { prop: "driverName", label: "司机姓名" },
        { prop: "driverPhone", label: "司机手机" },
        { prop: "vehicleModel", label: "车辆型号" },
        { prop: "createdTime", label: "排队时长" },
      ],
      dialogVisible: false,
      rowData: {},
      form: {
        organizationId: null,
        stationName: "",
      },
      rules: {
        organizationId: [
          { required: true, message: "请选择机构名称", trigger: "blur" },
        ],
        stationName: [{ required: true, message: "请输入场站名称" }],
      },
      // 地图上下文
      mapCtx: null,
      // 鼠标工具
      mouseTool: null,
      actionType: "draw", //绘制draw || 挖空hollow
      targetPlace: {},
      // 地图当前城市,用于搜索
      cityAdcode: null,
      searchText: "",

      drawer: false,
    };
  },
  async created() {
    await this.mixinOrganizations();
  },
  mounted() {},
  methods: {
    async showDrawer(row) {
      const url = "/api/v1/manage/airport/stationRail/vehicle";
      const { code, data } = await this.$axios.get(url, {
        id: row.id,
      });
      if (code === 1) {
        this.tableData = data.map((item) => {
          return {
            ...item,
            createdTime: this.getTimeDifference(
              new Date().getTime(),
              item.created * 1000
            ),
          };
        });
        this.drawer = true;
      }
    },

    getTimeDifference(timestamp1, timestamp2) {
      var diff = Math.abs(timestamp1 - timestamp2);
      var hours = Math.floor(diff / (1000 * 60 * 60));
      var minutes = Math.floor(diff / (1000 * 60)) % 60;
      // var seconds = Math.floor(diff / 1000) % 60;
      if (hours == 0) {
        return minutes + "分钟 ";
      }
      return hours + "小时 " + minutes + "分钟 ";
    },
    drawerClose() {
      this.drawer = false;
    },
    // 新增
    addFn() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.initMap();
      });
    },
    // 编辑
    edit(row) {
      this.rowData = row;
      this.form = {
        organizationId: row.organizationId,
        stationName: row.stationName,
      };
      this.targetPlace = {
        ...row,
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.initMap();
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.form = {
        stationName: "",
        organizationId: null,
      };
      this.targetPlace = {};
      this.rowData = {};
      this.mapCtx = null;
      this.actionType = "draw";
      this.searchText = "";
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.targetPlace.polygon) {
            this.$message.warning("请选择区域");
            return false;
          }
          if (this.rowData.id) {
            this.putFn();
          } else {
            this.postFn();
          }
        }
      });
    },
    async postFn() {
      const url = "/api/v1/manage/airport/stationRail";
      let params = {
        organizationId: this.form.organizationId,
        enclosureAddress: this.targetPlace.enclosureAddress,
        stationName: this.form.stationName,
        province: this.targetPlace.province,
        city: this.targetPlace.city,
        area: this.targetPlace.area,
        cityCode: this.targetPlace.cityCode,
        adCode: this.targetPlace.adCode,
      };
      const { code } = await this.$axios.post(url, params);
      if (code == 1) {
        this.$message.success("场站信息保存成功");
        this.$refs.customTable.listFn();
        this.handleClose();
      }
    },
    async putFn() {
      const url = "/api/v1/manage/airport/stationRail";
      const { code } = await this.$axios.put(url, {
        id: this.rowData.id,
        organizationId: this.form.organizationId,
        enclosureAddress: this.targetPlace.enclosureAddress,
        stationName: this.form.stationName,
        province: this.targetPlace.province,
        city: this.targetPlace.city,
        area: this.targetPlace.area,
        cityCode: this.targetPlace.cityCode,
        adCode: this.targetPlace.adCode,
      });
      if (code == 1) {
        this.$message.success("场站信息保存成功");
        this.$refs.customTable.listFn();
        this.handleClose();
      }
    },
    // 更换状态
    async updateStatus(status, row) {
      let text =
        status == 1
          ? "是否确认启用场站？"
          : "是否确认停用场站？停用后该场站排队司机将退出排队状态";
      let title = status == 1 ? "启用场站" : "停用场站";
      this.$confirm(text, title)
        .then(async () => {
          let url = "/api/v1/manage/airport/stationRail/status";
          let params = {
            id: row.id,
            status: status,
          };
          let data = await this.$axios.put(url, params);
          if (data && data.code === 1) {
            this.$message.success("操作成功");
            this.$refs.customTable.listFn();
          } else {
            row.status = status == 1 ? 2 : 1;
          }
        })
        .catch(() => {
          row.status = status == 1 ? 2 : 1;
        });
    },
    async getInfo() {
      if (!this.rowData.id) {
        return false;
      }
      this.formAddPolygon(JSON.parse(this.rowData.enclosureAddress));
    },
    /* 初始化地图 */
    initMap() {
      this.mapCtx = new AMap.Map("mapCtx", {
        mapStyle: "amap://styles/572516903e2f1273ed9c97f54ebacd89",
        resizeEnable: true,
        zoom: 15,
        doubleClickZoom: false,
        center: new AMap.LngLat(104.065861, 30.657401),
      });

      this.getInfo();

      this.cityAdcode = this.mapCtx.getAdcode();

      // 初始化鼠标工具
      this.mouseTool = new AMap.MouseTool(this.mapCtx);

      // 鼠标绘制完毕事件
      this.mouseTool.on("draw", (e) => {
        this.mouseTool.close(true);
        // obj对象为绘制出来的覆盖物对象。
        this.mapCtx.remove(e.obj);

        // 绘制结果为多边形时
        if (e.obj.CLASS_NAME === "AMap.Polygon") {
          let corners = Array.from(e.obj.getPath(), (value) => [
            value.lng,
            value.lat,
          ]);
          this.handleDraw(corners);
        }
      });

      this.placeChange();
    },
    
    /* 地图搜索-选择地点 */
    async clickPoint(res) {
      this.$refs.form.clearValidate();
      this.form.stationName = res.name;
      this.mapCtx.setZoom(15);
      this.mapCtx.panTo(res.location);
    },
    /* 清空围栏数据 */
    emptyPolygon() {
      if (!this.targetPlace?.polygon) {
        this.$message.info("该地点未设置围栏");
        return;
      }
      this.$confirm(`确定要清空该围栏？`, "提示").then(() => {
        this.mapCtx.remove(this.targetPlace.polygon);
        this.targetPlace.polygon = null;
        this.actionType = "draw";
        this.actionTypeChange();
      });
    },
    /* 点击挖空 */
    clickHollow() {
      if (this.targetPlace?.polygon) {
        this.actionTypeChange(3);
      } else {
        this.$message.info("该地址没有围栏");
      }
    },
    /**
     * 处理绘制的多边形
     * @corners   多边形原始角数据
     */
    handleDraw(corners) {
      // 判断这个围栏是否规范,长度大于1说明生成了一个以上的围栏,同时difference函数会补全封闭角,千万别动这行
      let data = polygonClipping.difference([corners]);
      
      if (data.length > 1) {
        this.$message.warning("围栏线条禁止相交，请重新绘制");
        this.actionTypeChange();
        return;
      }
      // 绘制的点位顺序
      let len = data[0][0].length
      let index = data[0][0].findIndex(item => item[0] == corners[0][0])
      if(index > 0) {
        data[0][0].push(...data[0][0])
        let data1 = data[0][0].slice(index, index + len);
        data[0][0] = [...data1]
      }
      
      if (this.actionType === "draw") {
        this.formAddPolygon(data);
        this.formAddCityData(data);
      } else if (this.actionType === "hollow") {
        // 原围栏角数据
        let base = this.targetPlace.polygon.getPath();

        // 合并已建设围栏(多边形)的角数据和挖空多边形的角数据，生成新的的角数据
        data = this.mergeHollow(base, data);

        // 设置新生成的围栏
        this.targetPlace.polygon.setPath(data);
      }

      this.placeChange();
    },
    /* 聚焦目标地址变化，覆盖物重新渲染 */
    placeChange() {
      if (this.targetPlace?.polygon) {
        this.targetPlace.polygon.setOptions({
          fillOpacity: 0.5,
          fillColor: "#0288FF",
          strokeColor: "#68b6ff",
        });
        this.mapCtx.setFitView(
          this.targetPlace.polygon,
          true,
          [200, 200, 200, 200],
          16
        );
      }

      if (!this.targetPlace?.polygon) {
        this.actionTypeChange();
      }
    },
    /**
     * 绘制类型变化
     * @actionType 点击地址上单选框的回调参数
     */
    actionTypeChange(actionType) {
      if (actionType) {
        this.actionType = new Map([
          [1, "site"],
          [2, "draw"],
          [3, "hollow"],
        ]).get(actionType);
      }
      if (this.actionType == "draw") {
        // 若目标地址绘制类型为围栏(多边形)
        if (!this.targetPlace.polygon) {
          this.mouseTool.polygon({
            fillOpacity: 0.3,
            fillColor: "#0288FF",
            strokeColor: "#68b6ff",
          });
        }
        this.targetPlace.polygon = null;
      } else if (this.actionType == "hollow") {
        // 若目标地址绘制类型为挖空(多边形)
        this.mouseTool.polygon({
          fillColor: "gainsboro",
          strokeColor: "#fffffff0",
        });
      }
    },
    /**
     * 处理绘制的多边形 => form添加围栏(多边形)
     * @corners   多边形原始角数据
     */
    formAddPolygon(corners) {
      // 生成并添加围栏
      this.targetPlace.polygon = this.structurePolygon(corners);
    },
    /**
     * 原始角数据生成围栏(多边形)
     * @corners   多边形原始角数据
     */
    structurePolygon(corners) {
      let polygon = new AMap.Polygon({
        map: this.mapCtx,
        path: corners,
        fillOpacity: 0.5,
        strokeOpacity: 1,
        fillColor: "#deefff",
        strokeColor: "#68b6ff",
      });
      return polygon;
    },

    /**
     * 处理绘制的多边形 => form添加围栏(多边形)的城市信息数据
     * @corners   多边形原始角数据
     * @city      城市数据
     */
    async formAddCityData(corners) {
      console.log('corners::: ', corners);
      let resCity = null;
      if (corners.length > 0) {
        let arr = [];
        if (!Array.isArray(corners[0])) {
          arr = corners[0];
        } else {
          arr = corners[0][0][0];
        }

        let regeo = await this.$AMap.AMapReGeo(arr);
        resCity = regeo.regeocode?.addressComponent;

        if (resCity) {
          this.targetPlace.enclosureAddress =
            corners.length > 0 ? JSON.stringify(corners) : "";
          this.targetPlace.province = resCity.province || "";
          this.targetPlace.city = resCity.city || resCity.province;
          this.targetPlace.area = resCity.area || resCity.district;
          this.targetPlace.cityCode = resCity.citycode || "";
          this.targetPlace.adCode = resCity.adcode || "";
        } else {
          this.$message.error("获取围栏城市信息失败");
        }
      }
    },
    /**
     * 挖空角数据处理
     * @base      已建设围栏的原始角数据
     * @hollow    挖空多边形的原始角数据
     */
    mergeHollow(base, hollow) {
      let res = null;
      if (
        base[0] &&
        Array.isArray(base[0]) &&
        base[0][0] &&
        Array.isArray(base[0][0]) &&
        base.length > 1
      ) {
        /* 被挖断的围栏处理 */
        let all = [];
        for (let i = 0; i < base.length; i++) {
          let allRes = this.baseData(base[i], []);
          if (isPolygonsOverlap(hollow, allRes)) {
            allRes.push(hollow[0][0]);
            res = polygonClipping.difference(allRes);
            let len = res[0][0].length
            let index = res[0][0].findIndex(item => item[0] == base[0][0][0].lng)
            if(index > 0) {
              res[0][0].push(...res[0][0])
              let data1 = res[0][0].slice(index, index + len);
              res[0][0] = [...data1]
            }
          }
          all = [...all, ...res];
        }
        this.formAddCityData(all);
        return all;
      } else {
        /* 一般围栏处理 */
        let allRes = this.baseData(base);
        allRes.push(hollow[0][0]);
        res = polygonClipping.difference(allRes);
        let len = res[0][0].length
        let index = res[0][0].findIndex(item => item[0] == base[0][0][0].lng)
        if(index > 0) {
          res[0][0].push(...res[0][0])
          let data1 = res[0][0].slice(index, index + len);
          res[0][0] = [...data1]
        }
        
        this.formAddCityData(res);
        return res;
      }
    },
    /* 复杂围栏处理,比如一个围栏被挖断 */
    baseData(data, list = []) {
      if (!Array.isArray(data[0])) {
        let lnglat = data.map((val) => [val.lng, val.lat]);
        list.push(lnglat);
      } else {
        for (let i = 0; i < data.length; i++) {
          this.baseData(data[i], list);
        }
      }
      return list;
    },
  },
};
</script>

<style lang="less">
#czLine {
  .aTag {
    cursor: pointer;
    color: #409eff;
    text-decoration: underline;
  }
  .mapContent {
    position: relative;

    #mapCtx {
      width: 100%;
      height: 500px;
    }

    .buttons {
      width: 60%;
      height: 30px;
      display: flex;
      align-items: center;
      background-color: white;
      padding: 0.8rem;
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 2;

      .mapBtn {
        margin-left: 5px;
        padding: 2px 0;
        cursor: pointer;
        width: 30%;
        border: 1px black solid;
        text-align: center;
        border-radius: 3px;
        &:hover {
          border-width: 2px;
        }
      }
    }
  }
  .tableScopeSwitch .el-switch__label {
    position: absolute;
    display: none;
    color: #fff;
  }
  .el-switch__label * {
    font-size: 12px !important;
  }
  /*打开时文字位置设置*/
  .tableScopeSwitch .el-switch__label--right {
    z-index: 1;
    right: -6px; /*不同场景下可能不同，自行调整*/
  }
  /*关闭时文字位置设置*/
  .tableScopeSwitch .el-switch__label--left {
    z-index: 1;
    left: 20px; /*不同场景下可能不同，自行调整*/
  }
  /*显示文字*/
  .tableScopeSwitch .el-switch__label.is-active {
    display: block;
  }
  .tableScopeSwitch.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 50px !important; /*开关按钮的宽度大小*/
  }
}
</style>
